var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0223 4.07305L9.23945 0.290234C9.13398 0.184766 8.9916 0.125 8.84219 0.125H1.375C1.06387 0.125 0.8125 0.376367 0.8125 0.6875V15.3125C0.8125 15.6236 1.06387 15.875 1.375 15.875H12.625C12.9361 15.875 13.1875 15.6236 13.1875 15.3125V4.47207C13.1875 4.32266 13.1277 4.17852 13.0223 4.07305ZM11.8902 4.73047H8.58203V1.42227L11.8902 4.73047ZM11.9219 14.6094H2.07812V1.39062H7.38672V5.1875C7.38672 5.3833 7.4645 5.57109 7.60296 5.70954C7.74141 5.848 7.9292 5.92578 8.125 5.92578H11.9219V14.6094Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.457af2691e73089466a5319410d4bd0a.svg";
export { ForwardRef as ReactComponent };